import React from 'react';
import PropTypes from 'prop-types';

const HorseParentsTree = ({ father, mother }) => (
    <div className="family-tree__horse-parents">
        <div className="family-tree__horse-father">

            <div className="family-tree__horse-info">
                <div className="family-tree__horse-info-wrapper">
                    <div className="family-tree__horse-name">
                        {father.horseName}
                    </div>

                    <div className="family-tree__horse-details">
                        {father.horseBestRacePerf && 'R: BTW '}

                        {
                            father.progenyBestPerf &&
                            `B: ${father.progenyBestPerfCount} ${father.progenyBestPerf}`
                        }
                    </div>
                </div>
            </div>

            {father.parents && HorseParentsTree(father.parents)}
        </div>

        <div className="family-tree__horse-mother">
            <div className="family-tree__horse-info">
                <div className="family-tree__horse-info-wrapper">
                    <div className="family-tree__horse-name">
                        {mother.horseName}
                    </div>

                    <div className="family-tree__horse-details">
                        {mother.horseBestRacePerf && 'R: BTW '}

                        {
                            mother.progenyBestPerf &&
                            `B: ${mother.progenyBestPerfCount} ${mother.progenyBestPerf}`
                        }
                    </div>
                </div>
            </div>

            {mother.parents && HorseParentsTree(mother.parents)}
        </div>
    </div>
);

HorseParentsTree.propTypes = {
    father: PropTypes.shape({
        horseBestRacePerf: PropTypes.string,
        progenyBestPerf: PropTypes.string,
        progenyBestPerfCount: PropTypes.number,
    }),

    mother: PropTypes.shape({
        horseBestRacePerf: PropTypes.string,
        progenyBestPerf: PropTypes.string,
        progenyBestPerfCount: PropTypes.number,
    }),
};

export default HorseParentsTree;



// WEBPACK FOOTER //
// ./src/js/horse/weatherbysOverview/HorseParentsTree.jsx